module.exports = __webpack_public_path__ + "static/media/sync_blue.e38bee72.svg";